import Service, { inject as service } from '@ember/service';
import { waitForPromise } from '@ember/test-waiters';

export default class CdpService extends Service {
  ToolData = null;
  @service site;

  constructor() {
    super(...arguments);
    this.ToolData = null;
  }
  getToolData() {
    let configUrl = this.site.ConfigUrl + '?id=' + new Date().getTime();
    return waitForPromise(
      fetch(configUrl).then((response) => {
        // Load tool data from config file
        if (response.status === 404) {
          throw ('Failed with Invalid status ', response);
        } else {
          return response.json().then((data) => {
            data.pstURL = data.pstURL
              ? this.site.SiteUrl + '/' + this.site.AdiLocale + data.pstURL
              : '//www.analog.com/en/parametricsearch/11080';
            this.ToolData = data;
            return data;
          });
        }
      }),
    );
  }
}
